@let obs =
  {
    isDesktop: isDesktop$ | async,
    currentCity: currentCity$ | async,
    baseStores: baseStores$ | async,
  };

<h2 class="text-b1-m-900 text-lg-h4-s">Выбрать город</h2>

<sd-city-search
  [baseStores]="obs.baseStores"
  (filterBaseStores)="onFilterBaseStores($event)"
  (selectBaseStore)="onSelectBaseStore($event)"
></sd-city-search>

@if ((obs.currentCity && obs.currentCity.inDeliveryZone === false) || !filteredBaseStores.length) {
  <sd-no-delivery-message class="no-delivery-msg"></sd-no-delivery-message>
} @else {
  <div class="cities-container">
    <ul class="cities-list">
      @for (city of filteredBaseStores; track city.code) {
        <li
          class="city-item link-hover-underlined"
          [class]="city.isMain ? 'text-b3-s-700 text-md-b2-s-700' : 'text-b3-s-300 text-md-b2-s-500'"
          [class.is-main]="city.isMain"
          [class.active]="city.name === obs.currentCity?.name"
          (click)="onSelectBaseStore(city.code)"
        >
          <span>{{ city.name }}</span>
          @if (city.name === obs.currentCity?.name && !obs.isDesktop) {
            <sd-icon class="icon-size-xs icon-size-md-m" [type]="iconType.SUCCESS"></sd-icon>
          }
        </li>
      }
    </ul>
  </div>
}
